import React, { useState } from "react";
import style from "./gridRolePrivilege.module.css"

const gridRolePrivilege = () => {
    const [currentPage, setCurrentPage] = useState(1);
  // const entriesPerPage = 10;
  const [entriesPerPage, setEntriesPerPage] = useState(10);

  const [searchQuery, setSearchQuery] = useState("");

  const handleEntriesChange = (e: { target: { value: any } }) => {
    setEntriesPerPage(Number(e.target.value));
  };
  

  const tableData = [
    {
      srNo: 1,
      itemName: "Applicant",
      date: "09/06/2023",
    },
    {
      srNo: 2,
      itemName: "Level 1 Reviewer",
      date: "09/06/2023",
      
    },
    {
      srNo: 3,
      itemName: "Level 2 Reviewer",
      date: "09/06/2023",
      
    },
    {
      srNo: 4,
      itemName: "Level 3 Reviewor",
      date: "09/06/2023",
      
    },
    {
      srNo: 5,
      itemName: "System Admin",
      date: "09/06/2023",
      
    },
    // ... Add more data rows as needed
  ];

  const totalPages = Math.ceil(tableData.length / entriesPerPage);
  const startIndex = (currentPage - 1) * entriesPerPage;
  const endIndex = startIndex + entriesPerPage;
  const currentTableData = tableData.slice(startIndex, endIndex);

  const generateTableRows = () => {
    return currentTableData
      .filter(
        (row) =>
          row.itemName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          row.date.toLowerCase().includes(searchQuery.toLowerCase()) 
          // row.status.toLowerCase().includes(searchQuery.toLowerCase())
      )

      .map((row, index) => (
        <tr
          key={index}
          className={index % 2 === 0 ? style.whiteRow : style.greyRow}
        >
          <td>{row.srNo}</td>
          <td>{row.itemName}</td>
          <td>{row.date}</td>
          {/* <td>
            <button
              className={
                row.status === "Active"
                  ? style.activeButton
                  : style.inactiveButton
              }
            >
              {row.status}
            </button>
          </td> */}
          <td>
            <button className={style.editButton}>Edit</button>
          </td>
        </tr>
      ));
  };

  // Define the content for each section

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const generateTableCards = () => {
    return currentTableData
      .filter(
        (row) =>
          row.itemName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          row.date.toLowerCase().includes(searchQuery.toLowerCase())
      )
      .map((row, index) => (
        <div
          key={index}
          className={index % 2 === 0 ? style.whiteCard : style.greyCard}
        >
          <div>
            <b>Role Name:</b>  <br/> {row.itemName}
          </div>
          <div > <br/>
            <b className={style.dateContainer}>Date: <button className={style.editButton}>Edit</button> </b>  {row.date}
          </div>
          <div>
            
          </div>
        </div>
      ));
  };
  return (
    <div>
    <div className={style.bodyBox}>
      {/* Main content here */}
      <div className={style.bodyHeading}>
        <p className={style.bodyTitle}>Role Privileges </p>

        <div className={style.rightContent}>
          <button
            className="fa fa-th"
            style={{
              border: "none",
              backgroundColor: "#F0F0F5",
              color: "rgb(247, 185, 48)",
              padding: "13px",
              borderRadius: "5px"
            }}
          >
            {" "}
          </button>
          {/* <div className={style.inputContainerBody}> */}
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery} className={style.inputSearch}
              onChange={(e) => setSearchQuery(e.target.value)}
            />

          {/* </div> */}
          <button
            className="fa fa-filter"
            style={{
              border: "none",
              backgroundColor: "white",
              color: "#f7b930",
              padding: "13px",
              borderRadius: "5px"
            }}
          >
            {" "}
          </button>

        </div>
      </div>
      {/* <br /> */}

      <div className={style.verificationBox}>
        <div className={style.straightLineContent}>
          <span>Show</span> &nbsp;
          <select
            className={style.selectBox}
            value={entriesPerPage}
            onChange={handleEntriesChange}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>{" "}
          &nbsp;
          <span>entries</span>
          
        </div>
        <div className={style.inputContainerTable}>
  <br />
  <div className={style.cardContainer}>{generateTableCards()}</div>
  <p className={style.showingMessage}>
    Showing {startIndex + 1} to {Math.min(endIndex, tableData.length)} of{" "}
    {tableData.length} entries
  </p>

          <div className={style.paginationBtn}>
            <button onClick={handlePreviousPage}>Previous</button>
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i}
                onClick={() => setCurrentPage(i + 1)}
                className={currentPage === i + 1 ? style.currentPageBtn : ""}
              >
                {i + 1}
              </button>
            ))}
            <button onClick={handleNextPage}>Next</button>
          </div>
        </div>
        {/* container close */}
      </div>
      <hr />
      <center>
        <p className={style.footerBottom}>
          {" "}
          Copyright © 2023 CivicPlan. Designed by Stralto Global All rights
          reserved.
        </p>
      </center>
    </div>
  </div>

  )
}

export default gridRolePrivilege
